import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { CoreService } from 'src/app/core/helpers/core.service';
import { DataServiceService } from 'src/app/core/helpers/data-service.service';
import { GaService } from 'src/app/core/helpers/ga.service';

@Component({
  selector: 'loyaltic-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss']
})
export class MyProfileComponent implements OnInit {
  @Input() userReceipts: [];
  userId = '';
  IsUserAlreadyLoggedIn = false;
  selectedReceiptImage = '';

  constructor(private modalService: BsModalService,
    private dataService: DataServiceService,
    public translate: TranslateService,
    private router: Router,
    private authService: AuthService,
    private coreService: CoreService,
    private gaService: GaService
  ) {
    this.userId = this.authService.getUserId();
    if (this.userId) {
      this.IsUserAlreadyLoggedIn = true;
    }
  }

  ngOnInit() {
  }

  ReUpload() {    
  
    this.router.navigate(['/upload'], { fragment: 'uploadDiv' });
    localStorage.setItem('IsReUpload', '1');
  
  }

  openReceiptPreview(imageUrl: string) {
    this.selectedReceiptImage = imageUrl || '';
  }

  closeReceiptPreview() {
    this.selectedReceiptImage = '';
  }

  getReceiptStatusType(receipt: any): 'approved' | 'pending' | 'rejected' {
    if (receipt && receipt.isRejected) {
      return 'rejected';
    }

    const status = receipt && receipt.status ? receipt.status.toString().toLowerCase() : '';

    if (status.indexOf('reject') > -1 || status.indexOf('notapproved') > -1 ||
      status.indexOf('not approved') > -1 || status.indexOf('avvis') > -1) {
      return 'rejected';
    }

    if (status.indexOf('pending') > -1 || status.indexOf('vänt') > -1 || status.indexOf('vant') > -1) {
      return 'pending';
    }

    return 'approved';
  }
}
